module.exports = __webpack_public_path__ + "img/cover.a1200d52.jpg";